import React from 'react';

import { PageLayout } from 'src/components/common';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useEmployerStaffsList } from 'src/hooks/employerStaff';
import { useCurrentUserStaff } from 'src/hooks/user';
import { prepareEmployerStaffFilter } from 'src/utils/employerStaff';

import { prepareSearchStaffsFilter } from '../EmployerStaffWrapperCVandPEOStaff/utils';

import { EmployerStaffTableEMPAdmin } from './components';

export const EmployerStaffWrapperEMPAdmin: React.FC = () => {
  const { employerStaff } = useCurrentUserStaff();
  const employerId = employerStaff?.employer.id;

  const searchQueryVariables = useSearchQueryVariables(prepareSearchStaffsFilter);
  const { filter, sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();

  const filterQueryVariables = React.useMemo(() => prepareEmployerStaffFilter(filter), [filter]);

  const { employerStaffsList, employerStaffsCount, loading, refetch } = useEmployerStaffsList(
    {
      filter: {
        employerId: { equals: employerId },
        ...searchQueryVariables,
        ...filterQueryVariables,
      },
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    },
    !employerId,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <PageLayout titleContent="Staff" paperSx={pageLayoutPaperSx}>
      <EmployerStaffTableEMPAdmin
        employerId={employerId}
        employerStaffList={employerStaffsList}
        employerStaffCount={employerStaffsCount}
        onRefresh={refetchData}
        pagination={pagination}
        loading={loading}
      />
    </PageLayout>
  );
};
